import {
  Component,
  Host,
  OnInit,
  ViewEncapsulation
} from '@angular/core';

import { WizardComponent } from './wizard.component';
import { WizardStepComponent } from './wizard-step.component';
import { WizardSubstepComponent } from './wizard-substep.component';
import { WizardStep } from './wizard-step';

/**
 * Wizard review component
 *
 * Note: This component is expected to be direct descendant of wizard-step or wizard-substep.
 */

export class WizardReviewComponent implements OnInit {
  private wizard: WizardComponent;

  /**
   * The default constructor
   */
  constructor( wizard: WizardComponent) {
    this.wizard = wizard;
  }

  // Initialization

  /**
   * Setup component configuration upon initialization
   */
  ngOnInit(): void {
  }

  // Methods

  /**
   * Returns only wizard steps with review templates
   *
   * @returns {WizardStep[]} The wizard stepd or substepd
   */
  getReviewSteps(): WizardStep[] {
    return this.wizard.getReviewSteps();
  }

  // Private

  // Returns the step number for the given wizard step and substep
  private getSubstepNumber(step: WizardStepComponent, substep: WizardSubstepComponent) {
    return step.getDisplayNumber(substep);
  }

  // Returns only wizard steps with review templates
  private getReviewSubsteps(step: WizardStepComponent): WizardStep[] {
    return step.getReviewSteps();
  }

  // Toggles the review step control
  private toggleReview(step: WizardStep): void {
    step.config.expandReview = !step.config.expandReview;
  }

  // Toggles the review details control
  private toggleReviewDetails(step: WizardStep): void {
    step.config.expandReviewDetails = !step.config.expandReviewDetails;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  encapsulation: ViewEncapsulation.None,
  selector: 'pfng-wizard-review',
  template: `<div class="wizard-pf-review-page"><div class="wizard-pf-review-steps"><ul class="list-group"><li class="list-group-item" *ngFor="let step of getReviewSteps()"><a class="apf-form-collapse" [ngClass]="{'collapsed': step.config.expandReview !== true}" (click)="toggleReview(step)">{{step.config.title}}</a><div class="wizard-pf-review-substeps" [ngClass]="{'collapse': step.config.expandReview !== true}"><ul class="list-group" *ngIf="step.hasSubsteps"><li class="list-group-item" *ngFor="let substep of getReviewSubsteps(step)"><a class="apf-form-collapse" [ngClass]="{'collapsed': substep.config.expandReviewDetails !== true}" (click)="toggleReviewDetails(substep)"><span class="wizard-pf-substep-number">{{getSubstepNumber(step, substep)}}</span> <span class="wizard-pf-substep-title">{{substep.config.title}}</span></a><div class="wizard-pf-review-content" [ngClass]="{'collapse': substep.config.expandReviewDetails !== true}"><ng-template [ngTemplateOutlet]="substep.reviewTemplate"></ng-template></div></li></ul><div class="wizard-pf-review-content" [ngClass]="{'collapse': step.config.expandReviewDetails !== true}" *ngIf="step.reviewTemplate"><ng-template [ngTemplateOutlet]="step.reviewTemplate"></ng-template></div></div></li></ul></div></div>`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: WizardComponent, decorators: [{ type: Host }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
